import { createSlice } from '@reduxjs/toolkit';
import { AdSeriesProps, AdsGroupProps } from '@/utils/datatype';

interface AdjustStoreProps {
    adSeriesChange:  AdSeriesProps[],
    adGroupChange: AdsGroupProps[],
    selectedItems: AdSeriesProps[],
    adjustType: string,
    adjustPrice: string,
    adjustBudget: string,
    hasGroup: boolean;
}

export const adjustmentSliceForGoogle = createSlice({
    name: 'adjustmentForGoogle',
    initialState: {
        payload: {
            adSeriesChange: [],
            adGroupChange: [],
            hasGroup: false,
            selectedItems: [],
            adjustType: '',
            adjustPrice: '',
            adjustBudget: '',
        } as AdjustStoreProps
    },
    reducers: {
        storeAdSeriesChange: (state, action) => {
            state.payload.adSeriesChange = action.payload.adSeriesChange;
        },
        storeAdGroupChange: (state, action) => {
            state.payload.adGroupChange = action.payload.adGroupChange;
        },
        updateSelectedData: (state, action) => {
            state.payload.selectedItems = action.payload.selectedItems;
        },
        hasGroupDataInSelected: (state, action) => {
            state.payload.hasGroup = action.payload.hasGroup;
        },
        updateAdjustType: (state, action) => {
            state.payload.adjustType = action.payload.adjustType;
        },
        updateAdjustPrice: (state, action) => {
            state.payload.adjustPrice = action.payload.adjustPrice;
        },
        updateAdjustBudget: (state, action) => {
            state.payload.adjustBudget = action.payload.adjustBudget;
        },
        initStoreData: (state, action) => {
            state.payload = action.payload;
        }
    }
});

export const { initStoreData, storeAdSeriesChange, storeAdGroupChange, updateSelectedData, updateAdjustType, updateAdjustPrice, updateAdjustBudget, hasGroupDataInSelected } = adjustmentSliceForGoogle.actions;

export default adjustmentSliceForGoogle.reducer;